import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// common
import { updateReportFromReportListSuccess } from '../../../common/actions';
// helpers/constants
import * as G from '../../../helpers';
// report-common
import { getReportReducers } from '../../../report-common';
// feature invoice
import * as H from '../helpers';
// feature invoice/customer
import * as A from './actions';
//////////////////////////////////////////////////

const initial = {
  additionalFilters: {},
};

const {
  setReports,
  selectItem,
  initialState,
  setUsedReport,
  setListLoading,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  deleteItemSuccess,
  getItemListSuccess,
  setTableTitleFilter,
  resetListAndPagination,
  setInitialStateOmitReport,
  handleUpdateReportFromReportListSuccess,
} = getReportReducers(initial);

const setAdditionalFilters = (state, filters) => (
  P.$set('additionalFilters', filters, state)
);

const getConfigsSuccess = (state, configs) => (
  P.$set('configs', configs, state)
);

const changeInvoicesSuccess = (state, data) => H.changeInvoicesSuccess(state, data);

const readyForBillingSuccess = (state, data) => H.readyForBillingSuccess(state, data);

const updateCloInvoiceSuccess = (state, data) => {
  const { guid } = data;

  const invoice = P.$get(`itemList.${guid}`, state);
  const payments = G.transformPaymentsFromArrayToObjectWithReportKeys(data);

  const mappedInvoice = R.mapObjIndexed(
    (item, key) => R.pathOr(item, R.split('.', key), data),
    invoice,
  );

  const updatedInvoice = R.mergeRight(mappedInvoice, payments);

  return P.$set(`itemList.${guid}`, updatedInvoice, state);
};

export default createReducer({
  // report common
  [A.setReports]: setReports,
  [A.selectItem]: selectItem,
  [A.setUsedReport]: setUsedReport,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.deleteItemSuccess]: deleteItemSuccess,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.setInitialStateOmitReport]: setInitialStateOmitReport,
  [updateReportFromReportListSuccess]: handleUpdateReportFromReportListSuccess,
  // report common
  [A.getConfigsSuccess]: getConfigsSuccess,
  [A.setAdditionalFilters]: setAdditionalFilters,
  [A.changeInvoicesSuccess]: changeInvoicesSuccess,
  [A.readyForBillingSuccess]: readyForBillingSuccess,
  [A.updateCloInvoiceSuccess]: updateCloInvoiceSuccess,
}, initialState);
